import { render } from "./AgreementText.vue?vue&type=template&id=1d8e169f"
import script from "./AgreementText.vue?vue&type=script&lang=js"
export * from "./AgreementText.vue?vue&type=script&lang=js"
script.render = render

export default script